// PAWTY neobrutalist — testimonials rail arrow controls
// (sections/pawty-testimonials.liquid). Native horizontal overflow + direct
// scrollLeft assignment. No CSS scroll-snap: combining it with programmatic
// scrollLeft writes cancels the scroll mid-animation in most browsers.
(function () {
  function initRail(rail) {
    var section = rail.closest('[data-pawty-testi-section]');
    if (!section) return;

    var prevBtn = section.querySelector('[data-pawty-testi-prev]');
    var nextBtn = section.querySelector('[data-pawty-testi-next]');
    if (!prevBtn && !nextBtn) return;

    function cardStep() {
      var card = rail.querySelector('[data-pawty-testi-card]');
      if (!card) return rail.clientWidth * 0.5;
      var rect = card.getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(rail).gap) || 20;
      return rect.width + gap;
    }

    function updateArrowState() {
      var maxScroll = rail.scrollWidth - rail.clientWidth;
      if (prevBtn) prevBtn.disabled = rail.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = rail.scrollLeft >= maxScroll - 1;
    }

    function scrollByCards(count) {
      rail.scrollLeft += cardStep() * count;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByCards(-2);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByCards(2);
      });
    }

    rail.addEventListener('scroll', updateArrowState, { passive: true });
    window.addEventListener('resize', updateArrowState);
    updateArrowState();
  }

  function initAll() {
    document
      .querySelectorAll('[data-pawty-testi-rail]')
      .forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (evt) {
    var rail = evt.target.querySelector('[data-pawty-testi-rail]');
    if (rail) initRail(rail);
  });
})();
